<script lang="ts">
    import { onMount } from 'svelte';
    import { EasyVrpApp } from './EasyVrpApp';
    import EasyVrpFormResultOne from './EasyVrpFormResultOne.svelte';
    import { get } from 'svelte/store';
    import { mapContext } from './EasyVrpMap/MapContext';
    import type { AppOptionsType } from './EasyVrpApp.types';
    import { openModal } from 'svelte-modals';
    import ModalCustom from '../../shared/Modals/ModalCustom.svelte';
    import ModalExtraData from './ModalExtraData.svelte';
    import { api } from '../../../stores/api';
    import MenuContextEasyVrpDisplaySettings from './MenuContextEasyVrpDisplaySettings.svelte';

    export let app: EasyVrpApp;

    let processing = false;

    onMount(() => {
        app.getResultsApp()
            .loadResults($api)
            .then(() => {})
            .catch(error => {
                console.error('Error loading results:', error);
            })
            .finally(() => {
                processing = false;
                app = app; // Trigger reactivity
            });

        if (get(mapContext) !== null) {
            app.getMapManager().drawMapElements(get(mapContext));
            app = app;
        }

        return () => {
            app.getMapManager().clearMapElements();
            app = app; // Trigger reactivity
        };
    });
</script>

<div class:processing style="display: flex; flex-direction: column; gap: 10px;">
    <div
        style="display: flex; flex-direction: column; justify-content: flex-start; border-top: 1px solid #ccc;"
    >
        {#each app.getResultsApp().getResults() as result}
            <EasyVrpFormResultOne bind:app {result} bind:processing />
        {/each}
    </div>
</div>

<style>
    .processing {
        opacity: 0.5;
        pointer-events: none;
    }
</style>
